/** Linha rotulo/valor read-only, reutilizada nos cards de Organização e Conta. */
export function SettingRow({ label, value }: { readonly label: string; readonly value: string }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-foreground-muted">{label}</span>
      <span className="truncate font-medium text-foreground-primary" title={value}>
        {value}
      </span>
    </div>
  )
}
